import { buildVersion } from './build.version';

export const environment = {
  name: 'uat',
  production: true,
  version: buildVersion + '-UAT',
  dataCleanerUrl: 'https://api-datacleaner.kyloe.plus/uat-eu',
  dataRulesUrl: 'https://api-datarules.kyloe.plus/uat-eu',
  dataToolsUrl: 'https://api-datatoolsadmin.kyloe.plus/uat-eu', // data tools - the main lookup where each app in enabled.
  duplikitUrl: 'https://api-duplikit.kyloe.plus/uat-eu',
  metaDataUrl: 'https://api-datarules.kyloe.plus/uat-eu',
  webSocketUrl: 'wss://datarules-uat.kyloe.plus',
  clientId: 'e5e7db35-78ec-49d9-bb72-82591cfe516d', // This is the Dev Sandbox
  kyloeAuthHost: 'https://api-auth.kyloe.cloud/uat/authenticate/callback',
  featureFlagsUrl: 'https://platform-dev.kyloe.io/feature-flags/api/v1/client-init',
  ffApiKey: 'Kv5tiKDe4i8O7jFYZz5wNawc3d3hqJ8L7KlKXTRa',
  enableAnalytics: true,

  // AWS RUM Config
  guestRoleArn: 'arn:aws:iam::393399738482:role/RUM-Monitor-eu-west-1-393399738482-4486752306761-Unauth',
  identityPoolId: 'eu-west-1:6c1f5119-89c7-45cd-813e-deec47653a03',
  APPLICATION_ID: '54f77a31-3da6-431a-a51f-4d1f35165e8c',

  // Google Analytics Config
  googleAnalytics: 'G-1MR5M2BL0E',
  googleAnalyticsDTLite: 'G-2X20V5Q5TN',

  // Pendo
  pendoAPIKey: '7ce6958c-9e57-49f7-7905-76e0164d6042'
};
